<template>
  <div class="heatmap_type"
       :style="{ width: widthProp }">
    <div class="legend" v-if="eventType === 'tap'">
        <span class="tab">
          <i class="icon icon--heatmap-tap"></i> {{ $t('common.unit.tap') }}
        </span>
        <span class="tab">
          <i class="icon icon--heatmap-double-tap"></i> {{ $t('common.unit.doubleTap') }}
        </span>
    </div>
    <div class="choose" v-else-if="eventType === 'zoom'">
      <button class="tab"
              :class="{ active: heatmapType === 0 }"
              @click="setType(0)">
        <i class="icon icon--heatmap-zoom-in"></i> {{ $t('common.unit.zoomin') }}
      </button>
      <button class="tab"
              :class="{ active: heatmapType === 1 }"
              @click="setType(1)">
        <i class="icon icon--heatmap-zoom-out"></i> {{ $t('common.unit.zoomout') }}
      </button>
    </div>
    <div class="choose" v-else-if="eventType === 'swipe'">
      <button class="tab"
              :class="{ active: heatmapType === 0 }"
              @click="setType(0)">
        <i class="icon icon--heatmap-swipe-vertical"></i> {{ $t('common.unit.vertical') }}
      </button>
      <button class="tab"
              :class="{ active: heatmapType === 1 }"
              @click="setType(1)">
        <i class="icon icon--heatmap-swipe-horizontal"></i> {{ $t('common.unit.horizontal') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeatmapType',
  props: [
    'eventType',
    'heatmapType'
  ],
  methods: {
    setType (value) {
      this.$emit('setHeatmapType', value)
    }
  },
  computed: {
    widthProp () {
      let scrollDiv = document.createElement('div')
      scrollDiv.style.overflow = 'scroll'
      document.body.appendChild(scrollDiv)
      let scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
      scrollDiv.remove()
      return `calc(100% - ${scrollbarWidth}px)`
    }
  }
}
</script>

<style lang="scss">
.heatmap_type {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 5;
  height: 41px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  text-align: center;

  .icon {
    vertical-align: middle;
    transform: translateY(-1px);
  }

  .legend {
    .tab {
      display: inline-block;
      line-height: 26px;
      height: 26px;
      margin: 8px 10px;
      color: #ffffff;
    }
  }

  .choose {
    display: inline-block;
    border-radius: 5px;
    border: solid 1px rgba(255, 255, 255, 0.1);
    background-color: rgba(0, 0, 0, 0.4);
    height: 26px;
    margin: 8px 0;
    padding: 0;

    .tab {
      display: inline-block;
      line-height: 26px;
      height: 26px;
      margin: 0;
      padding: 0 10px 0 7px;
      color: #ffffff;
      opacity: 0.3;

      &.active {
        opacity: 1;
        border-radius: 5px;
        background-color: #ec0047;
      }
    }
  }
}
</style>
